import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-confirm',
  templateUrl: './success-confirm.component.html',
  styleUrls: ['./success-confirm.component.scss']
})
export class SuccessConfirmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
